/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonValidatorUptimeInfo = {
    BH: string;
    SGD: BabylonValidatorUptimeInfo.SGD;
};

export namespace BabylonValidatorUptimeInfo {

    export enum SGD {
        SIGNED = 'SIGNED',
        MISSED = 'MISSED',
        PROPOSED = 'PROPOSED',
    }


}

